import log from 'loglevel'
import axios from 'axios'

/* eslint class-methods-use-this: ["off"] */

export default class Audit {
  constructor() {
    log.info('[INFO] Initialize Audit Module')
  }

  fetchPercentages() {
    return new Promise((resolve, reject) => {
      axios
        .get('v1/order/audit/percentage/')
        .then(response => {
          log.debug('[DEBUG] Success to fetch percentages')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch percentages')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updatePercentages(percentages) {
    return new Promise((resolve, reject) => {
      axios
        .put('v1/order/audit/percentage/', percentages)
        .then(response => {
          log.debug('[DEBUG] Success to update percentages')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update percentages')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
